import { z } from 'zod';
import { playerIdNameParser } from '../commonInbounds/utils/playerInboundUtils';
const CheckRecoverLoginResultInboundSchema = z
    .object({
    validPlayer: z.optional(z.string().transform(playerIdNameParser))
})
    .transform(
// add _type
({ ...rest }) => ({
    _type: 'check_recover_login_result',
    ...rest
}));
export const CHECK_RECOVER_LOGIN_PAYLOAD_DEFINITION = {
    zodSchema: CheckRecoverLoginResultInboundSchema
};
